import React from 'react';

// mui
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';

import type { SelectOption } from '@/components/mui/Form/Select/SelectBase';
import { countries, dokkaCountries } from '@/lib/countries';
import { listToSelectOptions } from '@/lib/helpers';

export const renderOption = ({ value, label }: SelectOption) => (
  <MenuItem key={`${value}-${label}`} value={value}>
    {label}
  </MenuItem>
);

export const renderDivider = () => (
  <ListSubheader key="divider">
    <Divider />
  </ListSubheader>
);

// The dokka countries head the list, ruled off from the rest. The head's length
// is read from the list that defines it, so adding a country there moves the
// divider with it instead of leaving a gap.
export const renderCountryOptions = () => {
  const options = listToSelectOptions(countries);
  return [
    ...options.slice(0, dokkaCountries.length).map(renderOption),
    renderDivider(),
    ...options.slice(dokkaCountries.length).map(renderOption),
  ];
};
